import { render, staticRenderFns } from "./resultAuthReject.vue?vue&type=template&id=85bb0a86&"
import script from "./resultAuthReject.vue?vue&type=script&lang=js&"
export * from "./resultAuthReject.vue?vue&type=script&lang=js&"
import style0 from "./resultAuthReject.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports